import { Switch } from "@/src/components/ui/switch";

export default function SettingsToggle({ label, checked, onChange, disabled = false, icon = null, tooltip = null, children }) {
  return (
    <div className="qk-settings-row qk-settings-toggle">
      <div className="flex items-center gap-3">
        <span className="qk-settings-row-icon">{icon}</span>
        <span className="qk-settings-row-label">{label}</span>
        {tooltip}
      </div>
      <Switch onCheckedChange={onChange} checked={checked} disabled={disabled} />
      {children}
    </div>
  );
}
